import {
  INGREDIENT_LIBRARY_PAGE_REQUEST,
  INGREDIENT_LIBRARY_CHANGE_CATEGORY_ID_DROPDOWN,
  INGREDIENT_LIBRARY_CHANGE_INVENTORY_ID_DROPDOWN,
  INGREDIENT_LIBRARY_SET_ITEM_SUMMARY,
  INGREDIENT_LIBRARY_LIST_ITEM_REQUEST,
  INGREDIENT_LIBRARY_SET_ITEM_LIST,
  INGREDIENT_LIBRARY_SET_CATEGORY_LIST,
  INGREDIENT_LIBRARY_SET_CURRENT_CATEGORY_ID,
  INGREDIENT_LIBRARY_LIST_CATEGORY_REQUEST,
  INGREDIENT_LIBRARY_LIST_CATEGORY_WITH_UNCATEGORIZED_REQUEST,
  INGREDIENT_LIBRARY_SET_CURRENT_INVENTORY_ID,
  INGREDIENT_LIBRARY_SET_OUTLETS,
  INGREDIENT_LIBRARY_SET_FILTER_STATE,
  INGREDIENT_LIBRARY_SET_FILTER_ITEM,
  INGREDIENT_LIBRARY_ON_CHANGE_OUTLET_IDS,
  INGREDIENT_LIBRARY_SET_CURRENT_PAGE,
  INGREDIENT_LIBRARY_SET_TOTAL_PAGE,
  INGREDIENT_LIBRARY_UNSET_FILTER_STATE,
  INGREDIENT_LIBRARY_ITEM_LIST_EXPORT,
  INGREDIENT_LIBRARY_SET_TYPE_IMPORT,
  INGREDIENT_LIBRARY_SHOW_SECTION_UPLOADER,
  INGREDIENT_LIBRARY_ITEM_LIST_TEMPLATE,
  INGREDIENT_LIBRARY_ON_CLICK_CREATE_ITEM,
  INGREDIENT_LIBRARY_OPEN_RIGHT_COLUMN,
  INGREDIENT_LIBRARY_CLOSE_RIGHT_COLUMN,
  INGREDIENT_LIBRARY_SET_ITEM_DETAIL,
  INGREDIENT_LIBRARY_ON_CLICK_CANCEL,
  INGREDIENT_LIBRARY_ON_CLICK_ROW,
  INGREDIENT_LIBRARY_ON_DROP_IMAGE,
  INGREDIENT_LIBRARY_ON_DELETE_IMAGE,
  INGREDIENT_LIBRARY_ON_CLICK_BTN_ITEM_VARIANT,
  INGREDIENT_LIBRARY_SHOW_ITEM_VARIANT_MODAL,
  INGREDIENT_LIBRARY_HIDE_ITEM_VARIANT_MODAL,
  INGREDIENT_LIBRARY_SET_PREVIOUS_ITEM_FORM,
  INGREDIENT_LIBRARY_ON_CANCEL_ITEM_VARIANT_MODAL,
  INGREDIENT_LIBRARY_ON_CONFIRM_ITEM_VARIANT_MODAL,
  INGREDIENT_LIBRARY_SHOW_ITEM_INVENTORY_ALERT_MODAL,
  INGREDIENT_LIBRARY_HIDE_ITEM_INVENTORY_ALERT_MODAL,
  INGREDIENT_LIBRARY_ON_CLICK_BTN_ITEM_TRACKING,
  INGREDIENT_LIBRARY_ON_CANCEL_ITEM_INVENTORY_ALERT_MODAL,
  INGREDIENT_LIBRARY_ON_CONFIRM_ITEM_INVENTORY_ALERT_MODAL,
  INGREDIENT_LIBRARY_FILL_FORM_DETAIL_ITEM,
  INGREDIENT_LIBRARY_SET_MODIFIER_FOR_DETAIL_ITEM,
  INGREDIENT_LIBRARY_SET_MODIFIERS,
  INGREDIENT_LIBRARY_SET_ACTIVE_MODIFIER_IDS,
  INGREDIENT_LIBRARY_SET_MANAGE_ITEM_INVENTORY,
  INGREDIENT_LIBRARY_SUBMIT_FORM_CREATE,
  INGREDIENT_LIBRARY_SUBMIT_FORM_UPDATE,
  INGREDIENT_LIBRARY_HIDE_DELETE_MODAL,
  INGREDIENT_LIBRARY_SHOW_DELETE_MODAL,
  INGREDIENT_LIBRARY_DELETE_ITEM,
  INGREDIENT_LIBRARY_ON_CLICK_CREATE_NEW_CATEGORY,
  INGREDIENT_LIBRARY_CREATE_CATEGORY_SHOW_MODAL,
  INGREDIENT_LIBRARY_CREATE_CATEGORY_HIDE_MODAL,
  INGREDIENT_LIBRARY_SET_NEW_CATEGORY,
  INGREDIENT_LIBRARY_CANCEL_CREATE_NEW_CATEGORY,
  INGREDIENT_LIBRARY_CONFIRM_CREATE_NEW_CATEGORY,
  INGREDIENT_LIBRARY_SET_PREVIOUS_CATEGORIES,
  INGREDIENT_LIBRARY_SET_PREVIOUS_CATEGORY_ID,
  INGREDIENT_LIBRARY_SET_UNITS,
  INGREDIENT_LIBRARY_SET_UNCATEGORIZED,
  INGREDIENT_LIBRARY_STORE_UNCATEGORIZED,
  INGREDIENT_LIBRARY_SHOW_IMPORT_MODAL,
  INGREDIENT_LIBRARY_HIDE_IMPORT_MODAL,
  INGREDIENT_LIBRARY_ON_SUCCESS_IMPORT,
  INGREDIENT_LIBRARY_SHOW_COGS_MODAL,
  INGREDIENT_LIBRARY_HIDE_COGS_MODAL,
  INGREDIENT_LIBRARY_ON_CLICK_TRACKING_COGS,
  INGREDIENT_LIBRARY_ON_CLICK_CANCEL_COGS_MODAL,
  INGREDIENT_LIBRARY_ON_CONFIRM_COGS_MODAL,
  INGREDIENT_LIBRARY_SHOW_SAVE_TO_ALL_OUTLETS_MODAL,
  INGREDIENT_LIBRARY_HIDE_SAVE_TO_ALL_OUTLETS_MODAL,
  INGREDIENT_LIBRARY_SET_CREATED_OUTLETS,
  INGREDIENT_LIBRARY_SHOW_INPUT_COGS,
  INGREDIENT_LIBRARY_SHOW_INPUT_INVENTORY,
  INGREDIENT_LIBRARY_IS_SUBMITTING_FORM
} from './constants'

export function pageRequest () {
  return {type: INGREDIENT_LIBRARY_PAGE_REQUEST, payload: {}}
}

export function setUnits (units) {
  return {type: INGREDIENT_LIBRARY_SET_UNITS, payload: {units}}
}

export function setUncategorized (categories) {
  return {type: INGREDIENT_LIBRARY_SET_UNCATEGORIZED, payload: {categories}}
}

export function storeUncategorized (uncategorized) {
  return {type: INGREDIENT_LIBRARY_STORE_UNCATEGORIZED, payload: {uncategorized}}
}

export function librariesRequest (query, previousLibraries) {
  return {type: INGREDIENT_LIBRARY_LIST_ITEM_REQUEST, payload: {query, previousLibraries}}
}

export function listCategoryRequest () {
  return {type: INGREDIENT_LIBRARY_LIST_CATEGORY_REQUEST, payload: {}}
}

export function listCategoryWithUncategorizedRequest () {
  return {type: INGREDIENT_LIBRARY_LIST_CATEGORY_WITH_UNCATEGORIZED_REQUEST, payload: {}}
}

export function changeCategoryIdDropdown (categoryId) {
  return {type: INGREDIENT_LIBRARY_CHANGE_CATEGORY_ID_DROPDOWN, payload: {categoryId}}
}

export function changeInventoryIdDropdown (inventoryId) {
  return {type: INGREDIENT_LIBRARY_CHANGE_INVENTORY_ID_DROPDOWN, payload: {inventoryId}}
}

export function setLibraries (libraries) {
  return {type: INGREDIENT_LIBRARY_SET_ITEM_LIST, payload: {libraries}}
}

export function setCategories (categories) {
  return {type: INGREDIENT_LIBRARY_SET_CATEGORY_LIST, payload: {categories}}
}

export function setCurrentCategoryId (categoryId) {
  return {type: INGREDIENT_LIBRARY_SET_CURRENT_CATEGORY_ID, payload: {categoryId}}
}

export function setCurrentInventoryId (inventoryId) {
  return {type: INGREDIENT_LIBRARY_SET_CURRENT_INVENTORY_ID, payload: {inventoryId}}
}

export function setLibrarySummary (librarySummary) {
  return {type: INGREDIENT_LIBRARY_SET_ITEM_SUMMARY, payload: {librarySummary}}
}

export function setOutlets (outlets) {
  return {type: INGREDIENT_LIBRARY_SET_OUTLETS, payload: {outlets}}
}

export function setFilterState (categoryId, typeInventoryId, keyword) {
  return {type: INGREDIENT_LIBRARY_SET_FILTER_STATE, payload: {categoryId, typeInventoryId, keyword}}
}

export function unSetFilterState () {
  return {type: INGREDIENT_LIBRARY_UNSET_FILTER_STATE}
}

export function setFilterLibrary (categoryId, typeInventoryId, keyword, outletIds) {
  return {type: INGREDIENT_LIBRARY_SET_FILTER_ITEM, payload: {categoryId, typeInventoryId, keyword, outletIds}}
}

export function onChangeOutletIds (outletIds) {
  return {type: INGREDIENT_LIBRARY_ON_CHANGE_OUTLET_IDS, payload: {outletIds: outletIds}}
}

export function setCurrentPage (currentPage) {
  return {type: INGREDIENT_LIBRARY_SET_CURRENT_PAGE, payload: {currentPage}}
}

export function setTotalPage (totalPage) {
  return {type: INGREDIENT_LIBRARY_SET_TOTAL_PAGE, payload: {totalPage}}
}

export function libraryExportRequest (prefix, email, outlets, categoryId, inventoryId, keyword) {
  return {type: INGREDIENT_LIBRARY_ITEM_LIST_EXPORT, payload: {prefix, email, outlets, categoryId, inventoryId, keyword}}
}

export function setImportType (importType) {
  return {type: INGREDIENT_LIBRARY_SET_TYPE_IMPORT, payload: {importType}}
}

export function showSectionUploader (showSectionUploader) {
  return {type: INGREDIENT_LIBRARY_SHOW_SECTION_UPLOADER, payload: {showSectionUploader}}
}

export function downloadLibraryTemplate (prefix, email, outlets) {
  return {type: INGREDIENT_LIBRARY_ITEM_LIST_TEMPLATE, payload: {prefix, email, outlets}}
}

export function onClickCreateLibrary (uncategorized) {
  return {type: INGREDIENT_LIBRARY_ON_CLICK_CREATE_ITEM, payload: {uncategorized}}
}

export function openRightColumn () {
  return {type: INGREDIENT_LIBRARY_OPEN_RIGHT_COLUMN, payload: {}}
}

export function closeRightColumn () {
  return {type: INGREDIENT_LIBRARY_CLOSE_RIGHT_COLUMN, payload: {}}
}

export function setLibraryDetail (library) {
  return {type: INGREDIENT_LIBRARY_SET_ITEM_DETAIL, payload: {library}}
}

export function onClickCancel () {
  return {type: INGREDIENT_LIBRARY_ON_CLICK_CANCEL, payload: {}}
}

export function onClickRow (library) {
  return {type: INGREDIENT_LIBRARY_ON_CLICK_ROW, payload: {library}}
}

export function onDropImage (filesState) {
  return {type: INGREDIENT_LIBRARY_ON_DROP_IMAGE, payload: {filesState}}
}

export function onDeleteImage (filesState) {
  return {type: INGREDIENT_LIBRARY_ON_DELETE_IMAGE, payload: {filesState}}
}

export function onClickBtnLibraryVariant (previousLibraryForm) {
  return {type: INGREDIENT_LIBRARY_ON_CLICK_BTN_ITEM_VARIANT, payload: {previousLibraryForm}}
}

export function showLibraryVariantModal () {
  return {type: INGREDIENT_LIBRARY_SHOW_ITEM_VARIANT_MODAL, payload: {}}
}

export function hideLibraryVariantModal () {
  return {type: INGREDIENT_LIBRARY_HIDE_ITEM_VARIANT_MODAL, payload: {}}
}

export function showLibraryInventoryAleryModal () {
  return {type: INGREDIENT_LIBRARY_SHOW_ITEM_INVENTORY_ALERT_MODAL, payload: {}}
}

export function hideLibraryInventoryAleryModal () {
  return {type: INGREDIENT_LIBRARY_HIDE_ITEM_INVENTORY_ALERT_MODAL, payload: {}}
}

export function setPreviousLibraryForm (previousLibraryForm) {
  return {type: INGREDIENT_LIBRARY_SET_PREVIOUS_ITEM_FORM, payload: {previousLibraryForm}}
}

export function onCancelLibraryVariantModal () {
  return {type: INGREDIENT_LIBRARY_ON_CANCEL_ITEM_VARIANT_MODAL, payload: {}}
}

export function onConfirmLibraryVariantModal () {
  return {type: INGREDIENT_LIBRARY_ON_CONFIRM_ITEM_VARIANT_MODAL, payload: {}}
}

export function onClickBtnStartTracking (previousLibraryForm) {
  return {type: INGREDIENT_LIBRARY_ON_CLICK_BTN_ITEM_TRACKING, payload: {previousLibraryForm}}
}

export function onCancelLibraryInventoryAlertModal () {
  return {type: INGREDIENT_LIBRARY_ON_CANCEL_ITEM_INVENTORY_ALERT_MODAL, payload: {}}
}

export function onConfirmLibraryInventoryAlertModal (libraryInventoryForm, libraryForm) {
  return {type: INGREDIENT_LIBRARY_ON_CONFIRM_ITEM_INVENTORY_ALERT_MODAL, payload: {libraryInventoryForm, libraryForm}}
}

export function fillFormDetailLibrary (formatFormDetail) {
  return {type: INGREDIENT_LIBRARY_FILL_FORM_DETAIL_ITEM, payload: {formatFormDetail}}
}

export function getModifiersforLibrary (library) {
  return {type: INGREDIENT_LIBRARY_SET_MODIFIER_FOR_DETAIL_ITEM, payload: {library}}
}

export function setModifiers (modifiers) {
  return {type: INGREDIENT_LIBRARY_SET_MODIFIERS, payload: {modifiers}}
}

export function setManageLibraryInventoryIds (libraryVariant) {
  return {type: INGREDIENT_LIBRARY_SET_MANAGE_ITEM_INVENTORY, payload: {libraryVariant}}
}

export function setActiveModifierIds (modifierIds) {
  return {type: INGREDIENT_LIBRARY_SET_ACTIVE_MODIFIER_IDS, payload: {modifierIds}}
}

export function submitFormCreate (values, allOutlet, libraries, outletId, summary) {
  return {type: INGREDIENT_LIBRARY_SUBMIT_FORM_CREATE, payload: {values, allOutlet, libraries, outletId, summary}}
}

export function submitFormUpdate (libraryId, values, allOutlet, libraries) {
  return {type: INGREDIENT_LIBRARY_SUBMIT_FORM_UPDATE, payload: {libraryId, values, allOutlet, libraries}}
}

export function showDeleteModal () {
  return {type: INGREDIENT_LIBRARY_SHOW_DELETE_MODAL, payload: {}}
}

export function hideDeleteModal () {
  return {type: INGREDIENT_LIBRARY_HIDE_DELETE_MODAL, payload: {}}
}

export function deleteLibrary (library, previousLibraries, summary) {
  return {type: INGREDIENT_LIBRARY_DELETE_ITEM, payload: {library, previousLibraries, summary}}
}

export function onClickCreateNewCategory (category, previousCategories, previousCategoryId) {
  return {type: INGREDIENT_LIBRARY_ON_CLICK_CREATE_NEW_CATEGORY, payload: {category, previousCategories, previousCategoryId}}
}

export function showNewCategoryModal () {
  return {type: INGREDIENT_LIBRARY_CREATE_CATEGORY_SHOW_MODAL, payload: {}}
}

export function hideNewCategoryModal () {
  return {type: INGREDIENT_LIBRARY_CREATE_CATEGORY_HIDE_MODAL, payload: {}}
}

export function setNewCategory (category) {
  return {type: INGREDIENT_LIBRARY_SET_NEW_CATEGORY, payload: {category}}
}

export function onConfirmCreateNewCategory (category) {
  return {type: INGREDIENT_LIBRARY_CONFIRM_CREATE_NEW_CATEGORY, payload: {category}}
}

export function onCancelCreateNewCategory (previousCategories, previousCategoryId) {
  return {type: INGREDIENT_LIBRARY_CANCEL_CREATE_NEW_CATEGORY, payload: {previousCategories, previousCategoryId}}
}

export function setPreviousCategories (categories) {
  return {type: INGREDIENT_LIBRARY_SET_PREVIOUS_CATEGORIES, payload: {categories}}
}

export function setPreviousCategoryId (categoryId) {
  return {type: INGREDIENT_LIBRARY_SET_PREVIOUS_CATEGORY_ID, payload: {categoryId}}
}

export function showImportModal () {
  return {type: INGREDIENT_LIBRARY_SHOW_IMPORT_MODAL, payload: {}}
}

export function hideImportModal () {
  return {type: INGREDIENT_LIBRARY_HIDE_IMPORT_MODAL, payload: {}}
}

export function onSuccessImport () {
  return {type: INGREDIENT_LIBRARY_ON_SUCCESS_IMPORT, payload: {}}
}

export function showTrackingCOGSModal () {
  return {type: INGREDIENT_LIBRARY_SHOW_COGS_MODAL, payload: {}}
}

export function hideTrackingCOGSModal () {
  return {type: INGREDIENT_LIBRARY_HIDE_COGS_MODAL, payload: {}}
}

export function onClickBtnTrackingCOGS (previousLibraryForm) {
  return {type: INGREDIENT_LIBRARY_ON_CLICK_TRACKING_COGS, payload: {previousLibraryForm}}
}

export function onCancelCOGSModal () {
  return {type: INGREDIENT_LIBRARY_ON_CLICK_CANCEL_COGS_MODAL, payload: {}}
}

export function onConfirmCOGSModal (libraryCOGSForm, previousLibraryForm, showInputCOGS) {
  return {type: INGREDIENT_LIBRARY_ON_CONFIRM_COGS_MODAL, payload: {libraryCOGSForm, previousLibraryForm, showInputCOGS}}
}

export function showSaveToAllOutletsModal () {
  return {type: INGREDIENT_LIBRARY_SHOW_SAVE_TO_ALL_OUTLETS_MODAL, payload: {}}
}

export function hideSaveToAllOutletsModal () {
  return {type: INGREDIENT_LIBRARY_HIDE_SAVE_TO_ALL_OUTLETS_MODAL, payload: {}}
}

export function setCreatedOutlets (createdOutlets) {
  return {type: INGREDIENT_LIBRARY_SET_CREATED_OUTLETS, payload: {createdOutlets}}
}

export function showColInputCOGS (showInputCOGS) {
  return {type: INGREDIENT_LIBRARY_SHOW_INPUT_COGS, payload: {showInputCOGS}}
}

export function showColInputInventory (showInputInventory) {
  return {type: INGREDIENT_LIBRARY_SHOW_INPUT_INVENTORY, payload: {showInputInventory}}
}

export function isSubmittingForm (isSubmittingForm) {
  return {type: INGREDIENT_LIBRARY_IS_SUBMITTING_FORM, payload: {isSubmittingForm}}
}



// WEBPACK FOOTER //
// ./app/actions/ingredients/library/index.js